export interface ReactiveCascadeResetTarget<TModel> {
    readonly fieldName: Extract<keyof TModel, string> | string;
    readonly value: unknown;
    readonly resetSelection?: () => void;
}

export interface ReactiveCascadeResetResult<TModel> {
    readonly updates: Partial<TModel>;
    readonly resetFields: readonly string[];
}

/**
 * Builds deterministic reset patches for dependent dropdown cascades.
 *
 * Host components keep their domain rules, while the library owns the repeated mechanics:
 * create a patch, run optional dropdown-selection resets, and report the affected fields.
 */
export class ReactiveCascadeController {
    public static createResetPatch<TModel>(
        targets: readonly ReactiveCascadeResetTarget<TModel>[],
    ): ReactiveCascadeResetResult<TModel> {
        const updates: Record<string, unknown> = {};
        const resetFields: string[] = [];

        for (const target of targets) {
            updates[target.fieldName] = target.value;
            resetFields.push(target.fieldName);
            target.resetSelection?.();
        }

        return {
            updates: updates as Partial<TModel>,
            resetFields,
        };
    }
}
